import React from 'react';
import DominatorStack from 'components/organisms/dominator-stacking/index';
import {BasePlayersDashboard} from 'desktop/sports/nascar/players-dashboard/classic';

class PlayersDashboard extends BasePlayersDashboard {
    render() {
        const Dashboard = super.render();

        return (
            <div>
                {Dashboard}
                <DominatorStack />
            </div>
        );
    }
}

export {PlayersDashboard};
